import script from "./CreateAMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAMessage.vue?vue&type=script&setup=true&lang=js"

import "./CreateAMessage.vue?vue&type=style&index=0&id=1e20571e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e20571e"]])

export default __exports__